module.exports = __webpack_public_path__ + "img/service_devops_2_mob_2x.8cc75a2b.jpg";